module.exports = __webpack_public_path__ + "9ccb65771eac6d1ff178dc577ff826cc.woff2";